<template>
  <div id="cookieList" class="page white">
    <el-container class="content-aside">
      <el-main class="cpl-main">
        <!-- Content -->
        <el-row :gutter="0" class="main-content-row hide-scrollbar hide-scrollbar">
          <div class="content-wrapper">
            <!-- Usercentrics Tracker Declaration List start -->
            <div class="uc-embed-tracker" uc-embed-type="matrix"></div>
            <!-- Usercentrics Tracker Declaration List end -->
          </div>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script src="./cookie-list.js"></script>
<style lang="scss" src="./cookie-list.scss"></style>
